var map = {
	"./ai/years.json": 3948,
	"./android/years.json": 3652,
	"./arvr/years.json": 5878,
	"./biotech/years.json": 6895,
	"./blockchain/years.json": 3656,
	"./devops/years.json": 5335,
	"./frontend/years.json": 9196,
	"./ios/years.json": 2666,
	"./pm/years.json": 2949,
	"./qa/years.json": 4742,
	"./quantum-computing/years.json": 1523,
	"./web/years.json": 4237
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 187;
module.exports = webpackAsyncContext;